(function($) {
  "use strict";

  jQuery(document).ready(function(){


    /* Match Heigh */  
    $(function() {
      $('.rhs_match_height > div').matchHeight();
    });




    /* jQuery MeanMenu */
    $('#mobile-menu-active').meanmenu({
      meanScreenWidth: "991",
      meanMenuContainer: ".mobile-menu-area .mobile-menu",
    });


    /*====== sidebarCart ======*/
    function sidebarCart() {
      var menuTrigger = $('.sidebar-trigger'),
          endTrigger = $('button.op-sidebar-close'),
          container = $('.sidebar-cart'),
          wrapper = $('.wrapper');

      wrapper.prepend('<div class="body-overlay"></div>');
      menuTrigger.on('click', function() {
        container.addClass('inside');
        wrapper.addClass('overlay-active');
      });

      endTrigger.on('click', function() {
        container.removeClass('inside');
        wrapper.removeClass('overlay-active');
      });

      $('.body-overlay').on('click', function() {
        container.removeClass('inside');
        wrapper.removeClass('overlay-active');
      });
    };
    sidebarCart();


    /*====== sidebarSearch ======*/
    function sidebarSearch() {
      var searchTrigger = $('button.sidebar-trigger-search'),
          endTriggersearch = $('button.search-close'),
          container = $('.main-search-active');

      searchTrigger.on('click', function() {
        container.addClass('inside');
      });

      endTriggersearch.on('click', function() {
        container.removeClass('inside');
      });

    };
    sidebarSearch();


    /*====== sidebarCart ======*/
    function sidebarNav() {
      var navbarTrigger = $('button.header-navbar-active'),
          endTrigger = $('button.op-sidebar-close'),
          container = $('.cur-lang-acc-active'),
          wrapper = $('.wrapper');

      navbarTrigger.on('click', function() {
        container.addClass('inside');
        wrapper.addClass('overlay-active');
      });

      endTrigger.on('click', function() {
        container.removeClass('inside');
        wrapper.removeClass('overlay-active');
      });

      $('.body-overlay').on('click', function() {
        container.removeClass('inside');
        wrapper.removeClass('overlay-active');
      });
    };
    sidebarNav();

    /* slider active */
    $('.slider-active').owlCarousel({
      loop: true,
      nav: false,
      autoplay: true,
      autoplayTimeout: 5000,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      item: 1,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    })


    /* testimonial active */
    $('.testimonial-active').owlCarousel({
      loop: true,
      autoplay: true,
      autoplayTimeout: 5000,
      nav: false,
      item: 1,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    })

    /* brand logo active */
    $('.brand-logo-active').owlCarousel({
      loop: true,
      nav: false,
      item: 5,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 3
        },
        1000: {
          items: 5
        },
        1200: {
          items: 5
        }
      }
    })




    /*----------------------------
    	Cart Plus Minus Button
    ------------------------------ */
    $(".cart-plus-minus").prepend('<div class="dec qtybutton">-</div>');
    $(".cart-plus-minus").append('<div class="inc qtybutton">+</div>');
    $(".qtybutton").on("click", function() {
      var $button = $(this);
      var oldValue = $button.parent().find("input").val();
      if ($button.text() == "+") {
        var newVal = parseFloat(oldValue) + 1;
      } else {
        // Don't allow decrementing below zero
        if (oldValue > 0) {
          var newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 1;
        }
      }
      $button.parent().find("input").val(newVal);
    });


    /*--
    Smooth Scroll
    -----------------------------------*/
    $('.scroll-top').on('click', function(e) {
      e.preventDefault();
      var link = this;
      $.smoothScroll({
        offset: -80,
        scrollTarget: link.hash
      });
    });


    /*---------------------
        countdown
      --------------------- */
    $('[data-countdown]').each(function() {
      var $this = $(this),
          finalDate = $(this).data('countdown');
      $this.countdown(finalDate, function(event) {
        $this.html(event.strftime('<span class="cdown day">%-D <p>Days</p></span> <span class="cdown hour">%-H <p>Hour</p></span> <span class="cdown minutes">%M <p>Min</p></span class="cdown second"> <span>%S <p>Sec</p></span>'));
      });
    });


    /* magnificPopup video popup */
    $('.video-popup').magnificPopup({
      type: 'iframe'
    });


    /*---------------------
    price slider
    --------------------- */
    var sliderrange = $('#slider-range');
    var amountprice = $('#amount');
    $(function() {
      sliderrange.slider({
        range: true,
        min: 20,
        max: 100,
        values: [0, 100],
        slide: function(event, ui) {
          amountprice.val("$" + ui.values[0] + " - $" + ui.values[1]);
        }
      });
      amountprice.val("$" + sliderrange.slider("values", 0) +
                      " - $" + sliderrange.slider("values", 1));
    });




    /*---------------------
    sidebar sticky
    --------------------- */
    $('.sidebar-active').stickySidebar({
      topSpacing: 80,
      bottomSpacing: 30,
      minWidth: 991,
    });

    $('.sidebar-active1').stickySidebar({
      topSpacing: 80,
      bottomSpacing: 30,
      minWidth: 991,
    });

    $('.sidebar-active3').stickySidebar({
      topSpacing: 80,
      bottomSpacing: 30,
      minWidth: 991,
    });



    /*---------------------
        filter active
    --------------------- */
    function singleProductFilter() {
      var trigger = $('.shop-filter-active'),
          container = $('.shop-filters-left'),
          container2 = $('.shop-filters-right');
      trigger.on('click', function(e) {
        e.preventDefault();
        container.toggleClass('is-visible');
        container2.toggleClass('is-visible');
      })
    }
    singleProductFilter();


    /*--- showlogin toggle function ----*/
    $('#showlogin').on('click', function() {
      $('#checkout-login').slideToggle(900);
    });


    /*--- showlogin toggle function ----*/
    $('#showcoupon').on('click', function() {
      $('#checkout_coupon').slideToggle(900);
    });


    /*--- showlogin toggle function ----*/
    $('#ship-box').on('click', function() {
      $('#ship-box-info').slideToggle(1000);
    });


    /*--- clickable menu active ----*/
    const slinky = $('#menu').slinky()


    /*====== sidebarCart ======*/
    function sidebarMainmenu() {
      var menuTrigger = $('.clickable-mainmenu-active'),
          endTrigger = $('button.clickable-mainmenu-close'),
          container = $('.clickable-mainmenu');

      menuTrigger.on('click', function(e) {
        e.preventDefault();
        container.addClass('inside');
      });

      endTrigger.on('click', function() {
        container.removeClass('inside');
      });
    };
    sidebarMainmenu();


    /*--------------------------
        09. ScrollUp
    ---------------------------- */
    $.scrollUp({
      scrollText: '<i class="ion-arrow-up-c"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });




    /* mega menu */
    $('.megamenus').parent('ul').addClass('mega-menu');
    $('.mega-menu').parent('li').addClass('static-menu');


    

    var $window = $(window);
    $window.on('scroll', function() {    
      var notific = $window.scrollTop();
      if (notific < 55) {
        $(".top-notification-bar").removeClass("d-none");
      }else{
        $(".top-notification-bar").addClass("d-none");
      }
    });

    
    


    /* Ajax Cart */
    $(".cart-item").on('click', function(){
      setTimeout(function () {
        $('.cart-item').addClass('sidebar-trigger');
        $('.wrapper').addClass('overlay-active');
        $('.sidebar-cart').addClass('inside');
      },1300);

      $(this).addClass("loading add-item");
      setTimeout(function () {
        $(".cart-item").removeClass("loading");
      },1000);
      setTimeout(function () {
        $(".cart-item").removeClass("add-item");
      },1300);

    });


    /* Ajax Wishlist */
    $(".action--wishlist").on('click', function(){
      $(this).addClass("loading-wishlist add-wishlist");
      setTimeout(function () {
        $(".action--wishlist").removeClass("loading-wishlist");
      },1000);
      setTimeout(function () {
        $(".add-wishlist").removeClass("add-wishlist");
      },2000);

    });


    /* Remove Attr  */   
    $('.disabled-add-to-cart').removeAttr('href');



    /*--------------------------
       Parallax Effect
    ---------------------------- */
    /*  Testimonioal  */ 

    $('#third').parallax("50%", 0.1);
    
    
    
    /*  Single Banner  */ 

    $('#singleBanner').parallax("50%", 0.1);
    
    


  });



})(jQuery);



